import { Suspense } from 'react';
import { Provider } from 'mobx-react';
import 'antd/dist/reset.css';
import '@/styles/globals.less';
import '@/styles/antd.less';

import stores from './stores';
import Router from './routes/Router';
// import { ConfigProviderContext, theme } from '@/constants/antdConfig';
import { ConfigProvider } from 'antd';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import StaticGEOReport from './pages/GEOReport/Static';
import { ConfigProviderContext } from './plugins/ModalFactory';


const is_build_report = process.env.BUILD_REPORT;
function App() {
  return (
    <Suspense fallback={<div>loading</div>}>
      <Provider {...stores}>
        <ConfigProvider {...ConfigProviderContext}>
          {is_build_report ? (
            <RouterProvider
              router={createBrowserRouter([
                {
                  path: '/geoReport',
                  element: <StaticGEOReport />,
                },
              ])}
            />
          ) : (
            <Router />
          )}
        </ConfigProvider>
      </Provider>
    </Suspense>
  );
}

export default App;
